import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import {
  Container, Row, Col, Card, CardBody, Spinner, Badge, Label, Button,
  Input, FormGroup, CardHeader, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap'
import moment from 'moment'
import currencyFormatter from '../../../../utils/currencyFormatter'
import DataTable from '../../../../components/Template/Table/DataTable'
import Select from '../../../../components/Template/Input/Select'
import Breadcrumbs from '../../../../components/Common/Breadcrumb'
import { getProposal } from '../../../../store/ducks/comercial'

class Proposal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isNewProposalDialogOpen: false,
      newProposalIsTech: false,
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params
    const { getProposal } = this.props

    if (id) getProposal(id)
  }

  formatStatus = status => {
    switch (status) {
      case 'Em Elaboração':
        return <Badge className="badge-soft-info mr-1">{status}</Badge>
      case 'Encaminhada':
        return <Badge className="badge-soft-info mr-1">{status}</Badge>
      case 'Em Análise':
        return <Badge className="badge-soft-warning mr-1">{status}</Badge>
      case 'A cadastrar':
        return <Badge className="badge-soft-warning mr-1">{status}</Badge>
      case 'Vendida':
        return <Badge className="badge-soft-success mr-1">{status}</Badge>
      case 'Contratada':
        return <Badge className="badge-soft-success mr-1">{status}</Badge>
      case 'Descartado':
        return <Badge className="badge-soft-danger mr-1">{status}</Badge>
      case 'Perdida':
        return <Badge className="badge-soft-danger mr-1">{status}</Badge>
      default:
        return <Badge className="badge-soft mr-1">{status}</Badge>
    }
  }

  render() {
    //const { isManager } = this.props.auth.user
    const { getProposalIsLoading, proposal } = this.props.comercial
    const { isNewProposalDialogOpen, newProposalIsTech } = this.state

    //if (!isManager) return <Redirect to="/" />

    if (getProposalIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (proposal && proposal.fields.id === this.props.match.params.id) {
      return (
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Proposta Comercial"
              breadcrumbItems={[]}
            />

            <Row>
              <Col>
                <h4>
                  {proposal.fields.Title}
                </h4>
              </Col>
            </Row>

            <Row className="flex-grow-1">
              <Col className="col-md-auto d-flex flex-column">
                <span style={labelStyle}>
                  Código
                </span>
                <span>
                  {proposal.fields.id}
                </span>
              </Col>
              <Col className="col-md-auto d-flex flex-column">
                <span style={labelStyle}>
                  Data de entrada
                </span>
                <span>
                  {moment(proposal.fields.createdDateTime).format('DD/MM/YYYY')}
                </span>
              </Col>
              <Col className="col-md-auto d-flex flex-column">
                <span style={labelStyle}>
                  Procedência
                </span>
                <span>
                  {proposal.fields.Proced_x00ea_ncia}
                </span>
              </Col>
              <Col className="col-md-auto d-flex flex-column">
                <span style={labelStyle}>
                  Status
                </span>
                <span>
                  {proposal.fields.Status0}
                </span>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Tabs>
                  <TabList>
                    <Tab>Geral</Tab>
                    <Tab>Cliente</Tab>
                    <Tab>Propostas</Tab>
                  </TabList>

                  <TabPanel>
                    <Row>
                      <Col xs={12} lg={4} className="mb-3">
                        <Row>
                          <Col>
                            <Label>
                              Descrição sumária
                            </Label>
                          </Col>
                          <Col className="d-flex justify-content-end">
                            <Button
                              size="sm"
                              color="link"
                            >
                              <i className="ri-pencil-line align-middle font-size-16" />
                            </Button>
                          </Col>
                        </Row>
                        <Input
                          disabled
                          type="textarea"
                        />
                      </Col>

                      <Col xs={12} lg={4} className="mb-3">
                        <Row>
                          <Col>
                            <Label>
                              Descrição dos serviços
                            </Label>
                          </Col>
                          <Col className="d-flex justify-content-end">
                            <Button
                              size="sm"
                              color="link"
                            >
                              <i className="ri-pencil-line align-middle font-size-16" />
                            </Button>
                          </Col>
                        </Row>
                        <Input
                          disabled
                          type="textarea"
                        />
                      </Col>

                      <Col xs={12} lg={4} className="mb-3">
                        <Row>
                          <Col>
                            <Label>
                              Município de execução
                            </Label>
                          </Col>
                          <Col className="d-flex justify-content-end">
                            <Button
                              size="sm"
                              color="link"
                            >
                              <i className="ri-pencil-line align-middle font-size-16" />
                            </Button>
                          </Col>
                        </Row>
                        <Select
                          isDisabled
                          isSearchable
                        />
                      </Col>
                    </Row>
                  </TabPanel>

                  <TabPanel>
                    <Row>
                      <Col xs={12} lg={4} className="mb-3">
                        <Row>
                          <Col>
                            <Label>
                              Nome
                            </Label>
                          </Col>
                          <Col className="d-flex justify-content-end">
                            <Button
                              size="sm"
                              color="link"
                            >
                              <i className="ri-pencil-line align-middle font-size-16" />
                            </Button>
                          </Col>
                        </Row>
                        <Input
                          disabled
                          value={proposal.fields.w7nx}
                        />
                      </Col>

                      <Col xs={12} lg={4} className="mb-3">
                        <Row>
                          <Col>
                            <Label>
                              CNPJ
                            </Label>
                          </Col>
                          <Col className="d-flex justify-content-end">
                            <Button
                              size="sm"
                              color="link"
                            >
                              <i className="ri-pencil-line align-middle font-size-16" />
                            </Button>
                          </Col>
                        </Row>
                        <Input
                          disabled
                        />
                      </Col>

                      <Col xs={12} lg={4} className="mb-3">
                        <Row>
                          <Col>
                            <Label>
                              Setor de atuação
                            </Label>
                          </Col>
                          <Col className="d-flex justify-content-end">
                            <Button
                              size="sm"
                              color="link"
                            >
                              <i className="ri-pencil-line align-middle font-size-16" />
                            </Button>
                          </Col>
                        </Row>
                        <Select
                          isDisabled
                          isSearchable
                          value={{
                            value: proposal.fields.Setores?.Label,
                            label: proposal.fields.Setores?.Label,
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} lg={6} className="mb-3">
                        <Row>
                          <Col>
                            <Label>
                              Contatos
                            </Label>
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col>
                            Nome
                          </Col>
                          <Col>
                            Email
                          </Col>
                          <Col xs={1} />
                          <Col xs={1} />
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <Input
                              disabled
                              value={proposal.fields.Nome_x0020_do_x0020_Contato}
                            />
                          </Col>
                          <Col>
                            <Input
                              disabled
                              value={proposal.fields.fcit}
                            />
                          </Col>
                          <Col xs={1}>
                            <Button
                              size="sm"
                              color="light"
                              style={{
                                width: 38,
                                height: 38,
                              }}
                            >
                              <i className="ri-pencil-line align-middle font-size-14" />
                            </Button>
                          </Col>
                          <Col xs={1}>
                            <Button
                              size="sm"
                              color="light"
                              style={{
                                width: 38,
                                height: 38,
                              }}
                            >
                              <i className="ri-delete-bin-6-line align-middle font-size-14" />
                            </Button>
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col>
                            <Button
                              size="sm"
                              color="light"
                            >
                              Adicionar
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </TabPanel>

                  <TabPanel>
                    {!isNewProposalDialogOpen && (
                      <Row>
                        <Col>
                          <Button
                            color="primary"
                            size="md"
                            onClick={() => this.setState({ isNewProposalDialogOpen: true })}
                          >
                            Nova proposta
                          </Button>
                        </Col>
                      </Row>
                    )}
                    {isNewProposalDialogOpen && (
                      <>
                        <Row className="mb-3">
                          <Col>
                            <h5>
                              Nova proposta
                            </h5>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col xs={12} lg={4} className="mb-3">
                                    <Row className="mb-3">
                                      <Col>
                                        <Label>Nome</Label>
                                        <Input
                                          className="form-control"
                                          type="text"
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                        <Label>Data de validade</Label>
                                        <Input
                                          className="form-control"
                                          type="text"
                                        />
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col xs={12} lg={8}>
                                    <Label>Descrição</Label>
                                    <Input
                                      className="form-control"
                                      type="textarea"
                                      rows={5}
                                    />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Card>
                              <CardBody className="pb-2">
                                <Row>
                                  <Col className="d-flex flex-direction-row">
                                    <Label>Proposta técnica</Label>
                                    <CustomInput
                                      className="ml-3"
                                      type="switch"
                                      id="newProposalIsTechSwitch"
                                      checked={newProposalIsTech}
                                      onChange={() => this.setState({ newProposalIsTech: !newProposalIsTech })}
                                    />
                                  </Col>
                                </Row>

                                {newProposalIsTech && (
                                  <>
                                    <Row>
                                      <Col xs={12} lg={6} className="mb-3">
                                        <Label>Prazo</Label>
                                        <Input
                                          className="form-control"
                                          type="text"
                                        />
                                      </Col>

                                      <Col xs={12} lg={6} className="mb-3">
                                        <Label>Responsável</Label>
                                        <Input
                                          className="form-control"
                                          type="text"
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                )}
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col xs={4}>
                                    <Label>Serviços</Label>

                                    <Button
                                      size="sm"
                                      color="light"
                                      className="ml-3"
                                    >
                                      Adicionar
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col xs={4}>
                                    <Label>Produtos</Label>

                                    <Button
                                      size="sm"
                                      color="light"
                                      className="ml-3"
                                    >
                                      Adicionar
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col xs={4}>
                                    <Label>Condições de execução</Label>

                                    <Button
                                      size="sm"
                                      color="light"
                                      className="ml-3"
                                    >
                                      Adicionar
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col xs={4}>
                                    <Label>Condições de pagamento</Label>

                                    <Button
                                      size="sm"
                                      color="light"
                                      className="ml-3"
                                    >
                                      Adicionar
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col xs={4}>
                                    <Label>Orçamento</Label>

                                    <Button
                                      size="sm"
                                      color="light"
                                      className="ml-3"
                                    >
                                      Adicionar
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Button
                              color="danger"
                              className="mr-3"
                              onClick={() => this.setState({ isNewProposalDialogOpen: false })}
                            >
                              Cancelar
                            </Button>

                            <Button
                              color="primary"
                              onClick={() => this.setState({ isNewProposalDialogOpen: false })}
                            >
                              Confirmar
                            </Button>
                          </Col>
                        </Row>
                      </>
                    )}
                  </TabPanel>

                </Tabs>
              </Col>
            </Row>
          </Container>
        </div>
      )
    }

    return null
  }
}

const labelStyle = {
  fontSize: '0.75rem',
  color: '#adb5bd',
  lineHeight: '1.5',
  marginTop: 16,
}

const mapStateToProps = state => ({
  auth: state.auth,
  comercial: state.comercial,
})
const mapDispatchToProps = dispatch => bindActionCreators({ getProposal }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Proposal)
